<template>
  <el-date-picker
    v-model="dateTime"
    type="datetimerange"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    @change="dateChange"
    :shortcuts="shortcuts"
  />
</template>
<script>
import { defineComponent, reactive, toRefs, onMounted, watchEffect } from "vue";
import { formatDateHMSSJC } from "@/utils/index.js";
import moment from "moment";
export default defineComponent({
  name: "HDateTimerange",
  props: {
    start: {
      type: String,
      default: "",
    },
    end: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "datetimerange",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    shortcutsActive: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const state = reactive({
      dateTime: [],
      shortcuts: [
        {
          text: "近一天",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            upDataTime([start, end]);
            return [start, end];
          },
        },
        {
          text: "近三天",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
            upDataTime([start, end]);
            return [start, end];
          },
        },
        {
          text: "近一周",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            upDataTime([start, end]);
            return [start, end];
          },
        },
        {
          text: "整时",
          value: () => {
            const start = moment(new Date()).format("YYYY-MM-DD 00:00:00");
            const end = moment(new Date()).format("YYYY-MM-DD 23:59:59");
            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            upDataTime([start, end]);
            return [start, end];
          },
        },
      ],
    });
    watchEffect(() => {
      if (!props.shortcutsActive) {
        state.dateTime = [];
        state.shortcuts = [];
        return;
      }
    });
    const dateChange = (val) => {
      console.log(props.shortcutsActive);
      if (val && val[0] !== "") {
        if (props.type == "daterange") {
          context.emit(
            "update:start",
            moment(val[0]).format("YYYY-MM-DD 00:00:00")
          );
          context.emit(
            "update:end",
            moment(val[1]).format("YYYY-MM-DD 23:59:59")
          );
        } else {
          context.emit(
            "update:start",
            moment(val[0]).format("YYYY-MM-DD HH:mm:ss")
          );
          context.emit(
            "update:end",
            moment(val[1]).format("YYYY-MM-DD HH:mm:ss")
          );
        }
        context.emit("change");
      } else {
        context.emit("update:start", "");
        context.emit("update:end", "");
      }
    };
    if (props.shortcutsActive) {
      dateChange(state.dateTime);
    }
    onMounted(() => {
      if (props.type == "daterange") {
        let start = moment(props.start).format("YYYY-MM-DD ");
        let end = moment(props.end).format("YYYY-MM-DD ");
        state.dateTime = [start + " 00:00:00", end + " 23:59:59"];
      } else {
        state.dateTime = [props.start, props.end];
      }
      console.log(props.type, state.dateTime, props.start);
    });
    const upDataTime = (val) => {
      context.emit(
        "update:start",
        moment(val[0]).format("YYYY-MM-DD HH:mm:ss")
      );
      context.emit("update:end", moment(val[1]).format("YYYY-MM-DD HH:mm:ss"));
    };
    return {
      ...toRefs(state),
      dateChange,
    };
  },
});
</script>
